import { Component } from "react";

export class NotFound extends Component {
    render() {
        return (
            <div id="not-found-wrapper">
                <h1 id="not-found-header">404 ⊙︿⊙</h1>
                <h3 id="not-found-subheader">Oops, seems like you are in the wrong place.</h3>
            </div>
        )
    }
}